import React, { useState, useEffect } from 'react';
import Immutable from 'immutable';
import qs from 'query-string';
import config from 'react-global-configuration';
import { useSelector } from 'react-redux';
import MarkerCluster from '../../../../components/Map/MarkerCluster';

// This is the initial searchquery, this allows us to give back markers in smaller bits instead of all at once.
const doSearchQuery = (query, currentPage, type, currentLanguage, isCampaignMap = false) => {
  const API_URL = config.get('API_URL');
  // Sets the query parameters.
  const queryParams = qs.stringify(query, {
    skipNull: true,
  });
  const url = `${API_URL}/${currentLanguage}/api/${type === 'vacancy' ? 'vacancies-with-locations' : 'locations'}?${queryParams}&page=${currentPage}&field_show_on_campaign_map_value=${isCampaignMap ? '1' : 'All'}`;
  return new Promise((resolve, reject) => {
    fetch(url)
      .then((response) => { return response.json(); })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

// This is the main react element, doing the initial and rendering the cluster.
const LocationsData = (props) => {
  const { query, callback, mapLocation, type, isCampaignMap, markersCallback = () => { } } = props;

  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [markers, setMarkers] = useState(Immutable.List());

  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language']));

  const fetchMarkersPage = () => {
    doSearchQuery(query, currentPage, type, currentLanguage, isCampaignMap)
      .then((response) => {
        const output = Immutable.fromJS(response.results);
        setTotalPages(response.pager.pages);
        setCurrentPage(currentPage + 1);
        setMarkers(output, currentPage);
      });
  };

  // This useEffect fires whenever the currentPage changes, and will fetch extra markers if not on the final page.
  useEffect(() => {
    if (totalPages > currentPage) {
      fetchMarkersPage();
    }
  }, [currentPage, query, totalPages]);

  // This is the initial call.
  useEffect(() => {
    fetchMarkersPage();
  }, []);

  useEffect(() => {
    markersCallback(markers);

  }, [markers]);

  return (callback && mapLocation) ? (
    <MarkerCluster lastPageLoaded={currentPage && currentPage === totalPages} markers={markers} callback={callback} mapLocation={mapLocation} />
  ) : (
    <></>
  );
};

export default LocationsData;
